import React from "react";
import { Button, CardContent } from "@material-ui/core";
import { ItemSpotlight } from "../Item";
import { Field, PhoneInput } from "./styles";
import { Formik } from "formik";
import "react-phone-number-input/style.css";
import { API } from "../../../../../shared/services";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { PersonOutline } from "@material-ui/icons";
import pt from "react-phone-input-2/lang/pt.json";

export default function DetailsSpotlight({ customer, setSpotlight }) {
  const { contact } = customer;
  const { name, phone, email } = contact;

  const { t } = useTranslation("Customer");

  async function handleSubmit(values) {
    const { name, phone, email } = values;

    try {
      await API.put(`customers/${customer.id}`, {
        customer: {
          contact: {
            name,
            phone,
            email,
          },
        },
      });

      toast.success(t("spotlights.contact.saveSuccess"));
    } catch (err) {
      err.response.status === 422
        ? toast.error(
            t("spotlights.contact.saveErrorContactTaken", {
              error_message: err.response.data[0].replace(
                /(\[?)(\]?)(\"?)/gm,
                ""
              ),
            })
          )
        : toast.error(t("spotlights.contact.saveError"));
    }
  }

  return (
    <ItemSpotlight leftAction={<PersonOutline />} title={contact.name}>
      <CardContent>
        <Formik
          initialValues={{ name, email, phone,  }}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            errors,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form>
              <Field
                name="name"
                label={t("spotlights.contact.labels.name")}
                value={values.name}
                helperText={errors.name}
                onChange={handleChange}
                variant="outlined"
              />

              <Field
                label={t("spotlights.contact.labels.email")}
                name="email"
                value={values.email ? values.email : ""}
                helperText={errors.email}
                onChange={handleChange}
                variant="outlined"
              />

              <PhoneInput
                enableSearch
                country={"br"}
                specialLabel={t("spotlights.contact.labels.phone")}
                defaultErrorMessage={errors.phone}
                value={values.phone}
                localization={pt}
                onChange={(value) => {
                  setFieldValue("phone", value);
                }}
              />

              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                Salvar
              </Button>
            </form>
          )}
        </Formik>
      </CardContent>
    </ItemSpotlight>
  );
}
